import { Box } from '@deity/falcon-ui';
import { ContentContainer } from 'layouts';
import type { FC } from 'react';

const ContentWithGrid: FC = ({ children }) => (
  <ContentContainer>
    <Box pt="xxxl" style={{ marginTop: '96px', paddingBottom: '100px', width: '100%' }}>
      {children}
    </Box>
  </ContentContainer>
);

export default ContentWithGrid;
